module.exports = __webpack_public_path__ + "static/media/logo_icon_web_white.187ad903.png";